<template>
  <div class="header_box flex_items">
    <div class="width flex_items_between">
      <div class="logo">
        <img class="logo_title" src="@img/common/logo_menu.png" alt />
      </div>
      <div class="flex_items">
        <div class="router_list">
          <router-link
            v-for="(item, index) in menu"
            :key="index + '_router'"
            :to="item.path"
            >{{ $t(item.name + "Router") }}</router-link
          >
        </div>
        <div class="language_list">
          <el-select
            v-model="language"
            @change="_language"
            aria-placeholder="语言"
          >
            <el-option
              v-for="(item, index) in languageList"
              :key="index + '_language'"
              :value="item.code"
              :label="item.label"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadeMenu from "@/router/headeMenu.js";
export default {
  data() {
    return {
      menu: HeadeMenu,
      language: sessionStorage.getItem("language") || "zh",
      languageList: [
        {
          label: this.$t("languagezh"),
          code: "zh",
        },
        {
          label: this.$t("languageen"),
          code: "en",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    _language() {
      sessionStorage.setItem("language", this.language);
      location.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.header_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  height: 80px;
  width: 100%;
  background-color: @mainColor;

  a {
    color: @whiteColor;
    text-decoration: none;
    margin: 0 20px;
    transition: all 0.5s ease;
    &.router-link-active {
      color: @activeColor;
      border-bottom: 1px solid @activeColor;
    }
    &:hover {
      color: @activeColor;
      transition: all 0.5s ease;
    }
  }

  .language_list {
    /deep/.el-input__inner {
      background: @mainColor;
      border: none;
      outline: none;
      color: @whiteColor;
      width: 100px;
    }
  }

  .logo_title {
    height: 150px;
    width: 300px;
  }
}
</style>